/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { IdentifiedCompanyResponse } from './';
import {
    IdentifiedCompanyResponseFromJSON,
    IdentifiedCompanyResponseFromJSONTyped,
    IdentifiedCompanyResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface SearchCompanyResponse
 */
export interface SearchCompanyResponse {
    /**
     * 
     * @type {Array<IdentifiedCompanyResponse>}
     * @memberof SearchCompanyResponse
     */
    companies: Array<IdentifiedCompanyResponse>;
}

/**
 * Check if a given object implements the SearchCompanyResponse interface.
 */
export function instanceOfSearchCompanyResponse(value: object): value is SearchCompanyResponse {
    if (!('companies' in value) || value['companies'] === undefined) return false;
    return true;
}

export function SearchCompanyResponseFromJSON(json: any): SearchCompanyResponse {
    return SearchCompanyResponseFromJSONTyped(json, false);
}

export function SearchCompanyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchCompanyResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'companies': ((json['companies'] as Array<any>).map(IdentifiedCompanyResponseFromJSON)),
    };
}

export function SearchCompanyResponseToJSON(value?: SearchCompanyResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'companies': ((value['companies'] as Array<any>).map((v) => IdentifiedCompanyResponseToJSON(v))),
    };
}

